import {VesselCallShort} from "~/queries";

export function getVesselCallStatusColor(status: VesselCallShort["status"]) {
    const COLOR_MAP = {
        "Ожидается": "#DA7C0F",
        "Завершен": "#28BA2C",
        "На рейде": "#7F64EA",
        "В порту": "#009ACF",
    }
    return COLOR_MAP[status];
}